import './Title.css'
import { getCategorySlug } from '../../utils/Utils';

const Title = ({category:{name,desc}}) => { 

return(

<div data-aos={`fade-in`} data-aos-duration="1500" className='Title' id={getCategorySlug(name)}>
<h1>{name}</h1>
<p>{desc}</p>
</div>

)
}

export default Title